import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import {
  getProducts,
  getProductsDatatable,
  createProduct,
  editProduct,
  getProductById,
  getProductsByProductGroupId,
} from './thunks';
import { ProductsState } from './types';

export const name = 'products';

export const getProductsAsync = createAsyncThunk(
  name + '/getProducts',
  getProducts
);

export const getProductsDatatableAsync = createAsyncThunk(
  name + '/getProductsDatatable',
  getProductsDatatable
);

export const createProductAsync = createAsyncThunk(
  name + '/createProduct',
  createProduct
);

export const editProductAsync = createAsyncThunk(
  name + '/editProduct',
  editProduct
);

export const getProductByIdAsync = createAsyncThunk(
  name + '/getProductById',
  getProductById
);

export const getProductsByProductGroupIdAsync = createAsyncThunk(
  name + '/getProductsByProductGroupId',
  getProductsByProductGroupId
);

const initialState: ProductsState = {
  products: {
    data: [],
    status: 'idle',
  },
  productsDatatable: {
    data: null,
    status: 'idle',
  },
  createProduct: {
    data: null,
    status: 'idle',
  },
  editProduct: {
    data: null,
    status: 'idle',
  },
  productById: {
    data: null,
    status: 'idle',
  },
  productsByProductGroupId: {
    data: [],
    status: 'idle',
  },
};

export const slice = createSlice({
  name: name,
  initialState,
  reducers: {
    clear: () => {
      return initialState;
    },
    clearProductById: (state) => {
      state.productById = {
        data: null,
        status: 'idle',
      };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getProductsAsync.pending, (state) => {
        state.products.status = 'loading';
      })
      .addCase(getProductsAsync.fulfilled, (state, action) => {
        state.products = {
          data: action.payload,
          status: 'idle',
        };
      })
      .addCase(getProductsAsync.rejected, (state) => {
        state.products.status = 'failed';
      })
      .addCase(getProductsDatatableAsync.pending, (state) => {
        state.productsDatatable.status = 'loading';
      })
      .addCase(getProductsDatatableAsync.fulfilled, (state, action) => {
        state.productsDatatable = {
          data: action.payload,
          status: 'idle',
        };
      })
      .addCase(getProductsDatatableAsync.rejected, (state) => {
        state.productsDatatable.status = 'failed';
      })
      .addCase(createProductAsync.pending, (state) => {
        state.createProduct.status = 'loading';
      })
      .addCase(createProductAsync.fulfilled, (state, action) => {
        state.createProduct = {
          data: action.payload,
          status: 'idle',
        };
      })
      .addCase(createProductAsync.rejected, (state) => {
        state.createProduct.status = 'failed';
      })
      .addCase(editProductAsync.pending, (state) => {
        state.editProduct.status = 'loading';
      })
      .addCase(editProductAsync.fulfilled, (state, action) => {
        state.editProduct = {
          data: action.payload,
          status: 'idle',
        };
      })
      .addCase(editProductAsync.rejected, (state) => {
        state.editProduct.status = 'failed';
      })
      .addCase(getProductByIdAsync.pending, (state) => {
        state.productById.status = 'loading';
      })
      .addCase(getProductByIdAsync.fulfilled, (state, action) => {
        state.productById = {
          data: action.payload,
          status: 'idle',
        };
      })
      .addCase(getProductByIdAsync.rejected, (state) => {
        state.productById.status = 'failed';
      })
      .addCase(getProductsByProductGroupIdAsync.pending, (state) => {
        state.productsByProductGroupId.status = 'loading';
      })
      .addCase(getProductsByProductGroupIdAsync.fulfilled, (state, action) => {
        state.productsByProductGroupId = {
          data: action.payload,
          status: 'idle',
        };
      })
      .addCase(getProductsByProductGroupIdAsync.rejected, (state) => {
        state.productsByProductGroupId.status = 'failed';
      });
  },
});

export const actions = slice.actions;

export default slice.reducer;
